import { render, staticRenderFns } from "./documentsPage.vue?vue&type=template&id=9d983f44"
import script from "./documentsPage.vue?vue&type=script&lang=js"
export * from "./documentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports